export default __webpack_public_path__ + "static/media/vacation.bd29d3f5.svg";